import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dookagfksabkmxmyalin.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvb2thZ2Zrc2Fia214bXlhbGluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM1Mjc5MzUsImV4cCI6MjA1OTEwMzkzNX0.iCaMVOuSzw8Mnb6mlOvCi6nFW7oSlAoa13C9nWRWiHw';
export const supabase = createClient(supabaseUrl, supabaseAnonKey);